import { render, staticRenderFns } from "./AddStatus.vue?vue&type=template&id=3e8b0cae"
import script from "./AddStatus.vue?vue&type=script&lang=js"
export * from "./AddStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports